<template>
    <el-dialog title="账户充值" :visible="true" width="600px" append-to-body @close="close">
    <template  v-if="step == 1">
        <div class="charge-methods">
            <h3>选择支付方式</h3>
            <el-row type="flex" justify="start">
                <div class="charge-methods-item methods-check">
                    <img src="../../common/images/wechat-icon.png" alt="">
                    微信
                </div>

            </el-row>
            
        </div>

        
        <div style="margin-top: 20px">
            <h3 style="padding-bottom: 10px">请选择充值套餐</h3>
            <div class="charge">
                <div class="charge-item" :class="{'charge-check' : activeRule && activeRule.payment_amount === item.payment_amount}" v-for="(item) in rechargeRules"
                :key="item.payment_amount" @click="activeRule = item">
                <img v-show="activeRule &&activeRule.payment_amount === item.payment_amount" class="charge-item-check"
                    src="../../common/images/select-mark.png" alt="">
                <p class="charge-item-money">{{ item.payment_amount }}元</p>
                <p class="charge-item-gift">赠{{ item.gift_amount }}元</p>
            </div>
            </div>
        </div>
    </template>

    <template v-else>
        <h3 style="padding-bottom: 0px;text-align: center">储值套餐:{{qrcodeInfo ? qrcodeInfo.ruleTitle : ''}}</h3>
        <div class="charge-qrcode">
             <qrcode-vue v-if="qrcodeInfo" :value="qrcodeInfo.code_url" size="300" level="H"></qrcode-vue>
        </div>
        <h3 style="padding-top: 20px;text-align: center">请用微信扫码上方二维码完成付款</h3>

    </template>
        

        <span slot="footer" class="dialog-footer">
            <el-button type="warning" @click="step = 1;activeRule=null" v-if="step > 1">上一步</el-button>
            <el-button type="primary" @click="queryQrcode" :disabled="activeRule === null" v-if="step == 1"  :loading="loading">下一步</el-button>
            <el-button type="primary" @click="queryPayment" v-if="step == 2"  :loading="loading">支付完成</el-button>
        </span>
    </el-dialog>
</template>
<script>
import QrcodeVue from 'qrcode.vue'
export default {
    components: {
        QrcodeVue
    },
    data() {
        return {
            step: 1,
            activeRule: null,
            rechargeRules: [],
            qrcodeInfo: null,
            loading: false,
        }
    },
    mounted() {
        this.queryBalance();
        this.step = 1;
    },
    methods: {
        close() {
            this.$emit('close');
        },
        queryPayment() {
            this.close();
        },
        queryQrcode() {
            this.loading = true;
            this.$API.getRechargeQrcode({payment_amount: this.activeRule.payment_amount}).then((response) => {
                if (response.code == 0 || response.code == 1000) {

                    this.qrcodeInfo = response.data
                    this.step++;
                } else {
                    Elmessage.error(response.message);
                }

                this.loading = false;
            }).catch(err => {
                this.loading = false;
            });
        },
        queryBalance() {
            this.loading = true;
            this.$API.listRechargeRules({}).then((response) => {
                if (response.code == 0 || response.code == 1000) {
                    this.rechargeRules = response.data;
                }

                this.loading = false;
            }).catch(err => {
                this.loading = false;
            });
        },
    }
}
</script>
<style scoped lang="scss">

.charge {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 10px;
    overflow-y: auto;

    .charge-check {
        border: 1px solid #25A589 !important;
        color: #25A589;
    }

    .charge-item {
        height: 60px;
        cursor: pointer;
        padding: 10px;
        border-radius: 5px;
        border: 1px solid #CCC;
        position: relative;
        overflow: hidden;

        .charge-item-check {
            // display:block;
            position: absolute;
            bottom: -2px;
            right: -2px;
            font-size: 18px;
            // background:#25A589;
            color: #FFF;
            width: 30px;
            height: 30px;
        }

        .charge-item-money {
            font-size: 18px;
        }

        .charge-item-gift {
            margin-top: 5px;
        }
    }
}

.charge-methods {

    .methods-check {
        border: 1px solid #25A589 !important;
        color: #25A589 !important;
        background: #d3ede7;
    }

    .charge-methods-item {
        width: 140px;
        height: 50px;
        text-align: center;
        font-size: 16px;
        border: 1px solid #CCC;
        margin-right: 30px;
        margin-top: 10px;
        border-radius: 3px;
        display: flex;
        align-items: center;
        padding: 10px;
        cursor: pointer;

        img {
            width: 30px;
            height: 30px;
            margin-right: 10px;
        }
    }

}


    .charge-qrcode {
        width: 300px;
        height: 300px;
        margin: 20px auto 0;
    }

</style>